/** @format */

import React from "react";
import FooterBottom from "./landing/FooterBottom";
import FooterSection from "./landing/FooterSection";
import MailChimpFormContainer from "./landing/MailChimpFormContainer";
import SocialMedia from "./landing/SocialMedia";

const Footer = () => {
  return (
    <div className="bg-[#710B95]" id="footer">
      <div className="mt-[91px] xl:px-24 px-8">
        <MailChimpFormContainer />
        <FooterSection />
        <SocialMedia />
      </div>
      <FooterBottom />
    </div>
  );
};

export default Footer;
